<template>
  <div class="flex flex-col min-h-screen">
    <div class="flex row mx-auto justify-center mt-24 md:mt-32">
        <div class="row w-full border-0 max-w-md rounded-md md:border-2">
          <form
            class="flex flex-col justify-end m-8 p-2 items-center"
            v-on:submit.prevent="validateBeforeSubmit"
          >
            <div class="flex flex-col text-left w-full mb-4">
              <!-- <IconLink :name="iconLock.name" :width="iconLock.w" :height="iconLock.h" :style="iconLock.style" /> -->
              <p class="text-left text-gray-700 font-semibold text-2xl mb-12 dark:text-gray-300">Please enter the password to view this case study.</p>
              <label class="pr-4 dark:text-white">Password</label>
              <input
                class="w-full border-black border-2 rounded-md p-2"
                type="password"
                name="password"
                v-model.trim="password"
              />
              <span v-if="error">
                <p class="text-left text-red-500">Incorrect password.</p>
              </span>
            </div>
            <button class="btn-green-primary w-full h-11" type="submit">
              Enter
            </button>
          </form>
        </div>
    </div>
          <div class="flex flex-row mx-auto justify-center mt-8">
        <p class="footNote text-center transform opacity-40 px-8 text-xs dark:text-white">MADE BY <a href="https://www.linkedin.com/in/saul-verde-martinez/" target="_blank" class="underline">SAUL VERDE</a> / GREENSLASH</p>
      </div>
  </div>
</template>

<script>
// SHA-256 of the allowed password 'test'
import sha256Hex from "../encoder.js";
const EXPECTED_HASH =
  "c22ad879c45d1f7399bb9c859838d7c43ee0dc875fbc256666fcc437088c32bf";

export default {
  name: "protected-portal",
  data() {
    return {
      error: null,
      password: null,
    };
  },
  methods: {
    async validateBeforeSubmit() {
      const input = this.password || "";
      const hash = await sha256Hex(input);
      if (hash === EXPECTED_HASH) {
        // Clear any previous error
        this.error = false;

        // Persist a session-only. If the browser is closed, user must log in again.
        sessionStorage.setItem("isAuthenticated", "true");

        // Redirect back to the original destination if provided
        const redirect = this.$route.query.redirect;
        if (redirect) return this.$router.push(redirect);

        // Fallback: navigate to home (preserve current lang param if present)
        this.$router.push({
          name: "home",
          params: { lang: this.$route.params.lang },
        });
      } else {
        this.error = true;
      }
    },
  }
};
</script>
